document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.querySelector('[data-quiz-result-carousel]');
  if (!carousel) return;

  const track = carousel.querySelector('[data-quiz-result-track]');
  const slides = Array.from(carousel.querySelectorAll('[data-quiz-result-slide]'));
  const prevButton = carousel.querySelector('[data-quiz-result-prev]');
  const nextButton = carousel.querySelector('[data-quiz-result-next]');
  const currentLabel = carousel.querySelector('[data-quiz-result-current]');
  const totalLabel = carousel.querySelector('[data-quiz-result-total]');
  const desktopBreakpoint = window.matchMedia('(min-width: 990px)');
  const itemsPerPage = 3;

  if (!track || !slides.length) return;

  let currentPage = 0;
  let totalPages = Math.max(1, Math.ceil(slides.length / itemsPerPage));

  function updateButtons() {
    if (!prevButton || !nextButton) return;
    prevButton.disabled = currentPage <= 0;
    nextButton.disabled = currentPage >= totalPages - 1;
  }

  function updateCounter() {
    if (currentLabel) currentLabel.textContent = String(currentPage + 1);
    if (totalLabel) totalLabel.textContent = String(totalPages);
  }

  function applyLayout() {
    const isDesktop = desktopBreakpoint.matches;

    if (!isDesktop) {
      track.style.transform = '';
      if (currentLabel) currentLabel.textContent = '1';
      updateButtons();
      return;
    }

    totalPages = Math.max(1, Math.ceil(slides.length / itemsPerPage));
    if (currentPage > totalPages - 1) currentPage = totalPages - 1;

    const viewport = carousel.querySelector('.quiz-result-carousel__viewport');
    const viewportWidth = viewport ? viewport.clientWidth : carousel.clientWidth;
    const gap = 28;
    const pageWidth = viewportWidth + gap;
    const translateX = currentPage * pageWidth;

    track.style.transform = `translateX(-${translateX}px)`;
    updateCounter();
    updateButtons();
  }

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      if (currentPage <= 0) return;
      currentPage -= 1;
      applyLayout();
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      if (currentPage >= totalPages - 1) return;
      currentPage += 1;
      applyLayout();
    });
  }

  window.addEventListener('resize', applyLayout);
  desktopBreakpoint.addEventListener('change', function () {
    currentPage = 0;
    applyLayout();
  });

  updateCounter();
  updateButtons();
  applyLayout();
});
